module.exports = __webpack_public_path__ + "img/water-fall.a6a81aad.svg";